import React, { Component } from 'react';

class OptionList extends Component {
    render() {
        const {className, children} = this.props;
        return (
            <div className={`${className ? className : ''} options`}>
                {children}
            </div>
        );
    }
}

OptionList.propTypes = {

};

export default OptionList;